(function () {
    'use strict';

    angular
        .module('app')
        .controller('StatisticsController', StatisticsController);

    StatisticsController.$inject = ['API', 'global', 'helpers',];

    function StatisticsController(API, global, helpers) {
        var vm = this;

        vm.loadingState = {
            latestConversions: false,
            latestOrders: false,
            subscribers: false,
            platforms: false,
            os: false,
            browsers: false,
            activeUsersPerDay: false,
            subscribersPerDay: false,
            latestRegistrations: false,
        };

        vm.platforms = {
            labels: [],
            data: [],
            colors: [
                '#e3342f',
                '#ffed4a',
                '#38c172',
                '#3490dc'
            ],
        };

        vm.os = {
            labels: [],
            data: [],
            colors: ['#38c172', '#ffed4a', '#e3342f', '#3490dc', '#f66d9b', '#9561e2', '#4185ab'],
        };

        vm.browsers = {
            labels: [],
            data: [],
            colors: ['#38c172', '#ffed4a', '#e3342f', '#3490dc', '#f66d9b', '#9561e2', '#4185ab'],
        };

        vm.activeUsersPerDay = {
            labels: [],
            data: [],
        };
        vm.newSubscribersPerDay = {
            labels: [],
            data: [],
        };

        vm.loadCampaignConversions = loadCampaignConversions;
        vm.campaignConversions = [];
        vm.campaignConversionFromDate = false;
        vm.campaignConversionToDate = false;
        vm.campaignConversionCategory = false;
        vm.hasLoadedCampaignConversions = false;
        vm.campaignConversionSetDate = campaignConversionSetDate;

        vm.latestConversions = [];
        vm.latestRegistrations = [];
        vm.latestOrders = [];
        vm.subscribers = [];
        vm.isDesktop = global.isDesktop;

        activate();

        function activate() {
            loadCampaignConversions();
            loadUnverifiedSchools();
            loadLatestRegistrations();
            loadNewSubscribersPerDay();
            loadStatisticsPlatforms();
            loadStatisticsOs();
            loadStatisticsBrowsers();
            loadLatestConversions();
            loadLatestOrders();
            loadSubscribers();
            loadStatisticsActiveUsersPerDay();
        }

        function loadCampaignConversions() {
            vm.loadingState.campaignConversions = true;
            var parameters = { action: 'campaign-conversions' };

            if (typeof vm.campaignConversionFromDate !== 'boolean') {
                parameters.from = helpers.getDatabaseDatetime(vm.campaignConversionFromDate);
            }

            if (typeof vm.campaignConversionToDate !== 'boolean') {
                parameters.to = helpers.getDatabaseDatetime(vm.campaignConversionToDate);
            }

            if (typeof vm.campaignConversionCategory === 'string' && vm.campaignConversionCategory !== 'all') {
                parameters.category = vm.campaignConversionCategory;
            }

            var promise = API.Statistic.query(parameters).$promise;
            promise.then(function (response) {
                vm.campaignConversions = [];

                angular.forEach(response, function (item) {
                    vm.campaignConversions.push(item);
                });
                vm.loadingState.campaignConversions = false;
                vm.hasLoadedCampaignConversions = true;
            }, function () {
                vm.loadingState.campaignConversions = false;
            });
        }

        function campaignConversionSetDate(fromOrTo) {
            if (fromOrTo === 'from') {
                vm.campaignConversionFromDate = new Date();
            } else if (fromOrTo === 'to') {
                vm.campaignConversionToDate = new Date();
            }
        }

        function loadLatestRegistrations() {
            vm.loadingState.latestRegistrations = true;

            var promise = API.Statistic.query({ action: 'latest-registrations' }).$promise;
            promise.then(function (response) {
                angular.forEach(response, function (item) {
                    vm.latestRegistrations.push(item);
                });
                vm.loadingState.latestRegistrations = false;
            }, function () {
                vm.loadingState.latestRegistrations = false;
            });
        }

        function loadNewSubscribersPerDay() {
            vm.loadingState.subscribersPerDay = true;

            API.Statistic.query({ action: 'new-subscribers-per-day' }).$promise.then(function (response) {
                angular.forEach(response, function (day) {
                    vm.newSubscribersPerDay.labels.push(day.date);
                    vm.newSubscribersPerDay.data.push(day.count);
                });
                vm.loadingState.subscribersPerDay = false;
            }, function () {
                vm.loadingState.subscribersPerDay = false;
            });
        }

        function loadUnverifiedSchools() {
            vm.loadingState.unverifiedSchools = true;

            API.School.search({ status: 'unverified', 'per-page': 10 }).$promise.then(function (response) {
                if (response.items) {
                    vm.unverifiedSchools = response.items;
                }
                vm.loadingState.unverifiedSchools = false;
            }, function () {
                vm.loadingState.unverifiedSchools = false;
            });
        }

        function loadStatisticsActiveUsersPerDay() {
            vm.loadingState.activeUsersPerDay = true;

            API.Statistic.query({ action: 'active-users-per-day' }).$promise.then(function (response) {
                angular.forEach(response, function (day) {
                    vm.activeUsersPerDay.labels.push(day.date);
                    vm.activeUsersPerDay.data.push(day.count);
                });
                vm.loadingState.activeUsersPerDay = false;
            }, function () {
                vm.loadingState.activeUsersPerDay = false;
            });
        }

        function loadStatisticsPlatforms() {
            vm.loadingState.platforms = true;

            API.Statistic.query({ action: 'platforms' }).$promise.then(function (response) {

                angular.forEach(response, function (platform) {
                    vm.platforms.labels.push(platform.platform);
                    vm.platforms.data.push(platform.count);
                });
                vm.loadingState.platforms = false;
            }, function () {
                vm.loadingState.platforms = false;
            });
        }

        function loadStatisticsOs() {
            vm.loadingState.os = true;

            API.Statistic.query({ action: 'os' }).$promise.then(function (response) {

                angular.forEach(response, function (os) {
                    vm.os.labels.push(os.os);
                    vm.os.data.push(os.count);
                });
                vm.loadingState.os = false;
            }, function () {
                vm.loadingState.os = false;
            });
        }

        function loadStatisticsBrowsers() {
            vm.loadingState.browsers = true;

            API.Statistic.query({ action: 'browser' }).$promise.then(function (response) {

                angular.forEach(response, function (browser) {
                    vm.browsers.labels.push(browser.browser);
                    vm.browsers.data.push(browser.count);
                });
                vm.loadingState.browsers = false;
            }, function () {
                vm.loadingState.browsers = false;
            });
        }

        function loadLatestConversions() {
            vm.loadingState.latestConversions = true;
            API.Statistic.query({ action: 'latest-conversions' }).$promise.then(function (response) {
                vm.latestConversions = response;
                vm.loadingState.latestConversions = false;
            }, function () {
                vm.loadingState.latestConversions = false;
            });
        }

        function loadLatestOrders() {
            vm.loadingState.latestOrders = true;
            API.Statistic.query({ action: 'latest-orders' }).$promise.then(function (response) {
                vm.latestOrders = response;
                vm.loadingState.latestOrders = false;
            }, function () {
                vm.loadingState.latestOrders = false;
            });
        }

        function loadSubscribers() {
            vm.loadingState.subscribers = true;
            API.Statistic.query({ action: 'subscribers' }).$promise.then(function (response) {
                vm.subscribers = response;
                vm.loadingState.subscribers = false;
            }, function () {
                vm.loadingState.subscribers = false;
            });
        }

    }
})();